import {styled} from '@mui/material/styles';
import {forwardRef} from 'react';
import {Link} from '../Link';
import {useHeaderState} from './HeaderStateContext';
import {HeaderAppendProps} from './types';
import {excludeComponentProps} from '../utils/excludeComponentProps';

const StyledHeaderAppend = styled('div', {
    ...excludeComponentProps('breakpoint', 'brandFontStack')
})<HeaderAppendProps>(({
    theme, brandFontStack
}) => ({
    backgroundColor: '#fff',
    padding: `${theme.tokens.FuelSpacing1} ${theme.tokens.FuelSpacing4}`,
    position: 'relative',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    boxShadow: `0 1px ${theme.tokens.FuelColorBorderLight}`,
    gridArea: 'header-append',
    zIndex: 1,

    '& .HeaderAppend-text': {
        fontSize: theme.tokens.FuelFontSizeBase,
        textDecoration: 'none',
        color: theme.tokens.FuelColorBrandPrimary,
        textOverflow: 'ellipsis',

        ...brandFontStack === 'jdSans' && {
            fontFamily: theme.tokens.FuelFontFamilyJdSansProMedium,
            fontSize: theme.tokens.FuelFontSizeHeading3
        },

        '&.HeaderAppend-link:hover': {
            color: theme.tokens.FuelColorTextLinkHovered
        }
    }
}));

export const HeaderAppend = forwardRef<HTMLDivElement, unknown>((_, ref) => {
    const {
        title, titleLink, brandFontStack
    } = useHeaderState();

    return (
        <StyledHeaderAppend
            brandFontStack={brandFontStack}
            ref={ref}
        >
            {titleLink ? (
                <Link
                    className='HeaderAppend-text HeaderAppend-link'
                    href={titleLink}
                >{title}</Link>
            ) : (
                <span className='HeaderAppend-text'>{title}</span>
            )}
        </StyledHeaderAppend>
    );
});

HeaderAppend.displayName = 'HeaderAppend';
